<template>
  <div class="gt-xs">
    <q-toolbar class="bg-grey-2">
      <q-toolbar-title class="text-100 text-bold">Usage-Based Pricing Chart</q-toolbar-title>
    </q-toolbar>

    <q-toolbar class="bg-grey-2">
      <q-toolbar-title class="text-075">
        The chart below helps you see how this plan is priced based on how much energy you consume each month.
      </q-toolbar-title>
    </q-toolbar>

    <q-card flat>
      <q-card-section>
        <canvas :id="random_id"></canvas>
      </q-card-section>

      <q-separator></q-separator>

      <q-card-section>
        <div class="text-blue-grey-8 text-075">
          *These estimates include all the recurring charges you'll see on your bill excluding government fees and taxes.
          Estimates are based on information provided by {{ plan.product.brand.name }}. These estimates should be
          confirmed using the information found in the Electricity Facts Label and Terms of Service. Actual price will
          vary according to your actual usage.
        </div>
      </q-card-section>

    </q-card>
  </div>
</template>

<script>
import { onMounted } from "vue";
import Chart from "chart.js/auto";
import Plans from "src/composables/Plans";

export default {
  name: "PlanChart",
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const random_id = Math.floor(Math.random() * 1024).toString()
    const { get_chart_data_for_plan } = Plans();
    const generate_chart = function ({ chart_data }) {
      let ctx = document.getElementById(random_id);
      let datasets = [];
      let labels = []

      datasets.push({
        type: 'bar',
        label: `${props.plan.product.name} Total Price`,
        data: chart_data.map(x => x.total),
        borderColor: `#09addd`,
        backgroundColor: `#09addd40`,
        yAxisID: 'total'
      });

      datasets.push({
        type: 'line',
        label: `${props.plan.product.name} Average Price`,
        data: chart_data.map(x => x.usage === 0 ? null : x.avg * 100),
        borderColor: `#ec5a41`,
        backgroundColor: `#ec5a41`,
        yAxisID: 'avg'
      });

      labels = chart_data.map(x => x.usage);
      return new Chart(
          ctx,
          {
            // type: 'line',
            data: {
              labels: labels,
              datasets: datasets
            },
            options: {
              responsive: true,
              plugins: {
                tooltip: {
                  callbacks: {
                    label: function (ctx) {
                      const data_index = ctx.dataIndex;
                      const plan_name = ctx.dataset.label;
                      const plan_price = ctx.dataset.data[data_index];

                      if (ctx.dataset.yAxisID === 'total') {
                        return `${plan_name}: $${plan_price}`;
                      }
                      else{
                        return `${plan_name} ${plan_price.toFixed(1)}¢`
                      }
                    }
                  }
                }
              },
              scales: {
                x: {
                  display: true,
                  title: {
                    display: true,
                    text: 'Usage in kWh'
                  }
                },
                total: {
                  type: 'linear',
                  display: true,
                  position: 'right',
                  title: {
                    display: true,
                    text: 'Total Price in $',
                    color: '#03a9f4'
                  },
                  ticks: {
                    color: '#03a9f4'
                  }
                },
                avg: {
                  type: 'linear',
                  display: true,
                  position: 'left',
                  title: {
                    display: true,
                    text: 'Avg Price in cents',
                    color: '#ec5a41',
                  },
                  ticks: {
                    color: '#ec5a41'
                  }
                }
              }
            }
          }
      );
    }

    onMounted(async () => {
      const chart_data = await get_chart_data_for_plan({ plan_id: props.plan._id });
      generate_chart({ chart_data })
    })
    return {
      random_id
    }
  }
}
</script>

<style scoped>

</style>
